export default function ShareCard({ snapshot, meta }) {
  const s = snapshot || {};
  const topSong = s.music?.top_songs?.[0];
  const news = (s.news || [])[0];
  const isUS = (meta?.region?.code || "").toUpperCase() === "US";
  const hiF = s.weather?.high_f;
  const loF = s.weather?.low_f;
  const hi = isUS ? hiF : (typeof hiF === "number" ? Math.round((hiF - 32) * 5 / 9) : "--");
  const lo = isUS ? loF : (typeof loF === "number" ? Math.round((loF - 32) * 5 / 9) : "--");
  const unit = isUS ? "F" : "C";
  return (
    <div
      className="w-full bg-paper-surface border-2 border-ink p-6"
      style={{ width: 640, maxWidth: "100%", background: "#FAF7F2", color: "#1A1C20" }}
      data-testid="share-card"
    >
      <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.25em] pb-2 border-b border-ink" style={{ fontFamily: "Special Elite, monospace" }}>
        <span>{meta?.region?.flag} {meta?.region?.name}</span>
        <span>TimeCapsule 24</span>
        <span>Vol. 24</span>
      </div>
      <div className="text-center mt-2 pb-3" style={{ borderBottom: "4px double #1A1C20" }}>
        <div className="uppercase tracking-[0.3em] text-[10px] text-[#4A4B46]" style={{ fontFamily: "Special Elite, monospace" }}>
          {meta?.long_date}
        </div>
        <h1
          className="font-black uppercase tracking-tighter leading-none mt-1"
          style={{ fontFamily: "Fraunces, serif", fontSize: 44 }}
        >
          The Time Capsule
        </h1>
      </div>

      <div className="mt-4">
        <div className="uppercase text-[10px] tracking-widest text-[#4A4B46]" style={{ fontFamily: "Special Elite, monospace" }}>— Front Page —</div>
        <h2 className="font-black uppercase leading-tight mt-1" style={{ fontFamily: "Fraunces, serif", fontSize: 26 }}>
          {news?.headline || "A day in history"}
        </h2>
        {news?.summary && (
          <p className="mt-2 text-[14px] leading-relaxed" style={{ fontFamily: "EB Garamond, serif" }}>
            {news.summary.slice(0, 220)}{news.summary.length > 220 ? "…" : ""}
          </p>
        )}
      </div>

      <div className="grid grid-cols-2 gap-0 mt-4 border-t-2 border-l-2 border-ink">
        <div className="border-r-2 border-b-2 border-ink p-3">
          <div className="uppercase text-[10px] tracking-widest text-[#4A4B46]" style={{ fontFamily: "Special Elite, monospace" }}>Weather</div>
          <div className="font-black" style={{ fontFamily: "Fraunces, serif", fontSize: 28 }}>
            {hi}°/{lo}°{unit}
          </div>
          <div className="uppercase text-[10px] tracking-widest text-[#4A4B46]" style={{ fontFamily: "Special Elite, monospace" }}>
            {s.weather?.condition} · {s.weather?.city}
          </div>
        </div>
        <div className="border-r-2 border-b-2 border-ink p-3">
          <div className="uppercase text-[10px] tracking-widest text-[#4A4B46]" style={{ fontFamily: "Special Elite, monospace" }}>#1 Song</div>
          <div className="font-bold leading-tight" style={{ fontFamily: "Fraunces, serif", fontSize: 18 }}>{topSong?.title}</div>
          <div className="uppercase text-[10px] tracking-widest text-[#4A4B46]" style={{ fontFamily: "Special Elite, monospace" }}>{topSong?.artist}</div>
        </div>
        <div className="border-r-2 border-b-2 border-ink p-3">
          <div className="uppercase text-[10px] tracking-widest text-[#4A4B46]" style={{ fontFamily: "Special Elite, monospace" }}>Top Film</div>
          <div className="font-bold leading-tight" style={{ fontFamily: "Fraunces, serif", fontSize: 16 }}>{s.cinema?.top_movies?.[0]?.title || "—"}</div>
        </div>
        <div className="border-r-2 border-b-2 border-ink p-3">
          <div className="uppercase text-[10px] tracking-widest text-[#4A4B46]" style={{ fontFamily: "Special Elite, monospace" }}>Bestseller</div>
          <div className="font-bold leading-tight" style={{ fontFamily: "Fraunces, serif", fontSize: 16 }}>{s.books?.bestsellers?.[0]?.title || "—"}</div>
        </div>
      </div>

      <div className="mt-3 p-3 bg-[#1A1C20] text-[#F2ECE4] flex flex-wrap items-center justify-between gap-2">
        <div className="uppercase text-[10px] tracking-widest" style={{ fontFamily: "Special Elite, monospace" }}>
          Gas {s.ambient?.gas_price || "—"} · {s.ambient?.stock_index?.name}: {s.ambient?.stock_index?.value}
        </div>
        <div className="uppercase text-[10px] tracking-widest" style={{ fontFamily: "Special Elite, monospace" }}>
          {(s.ambient?.slang || []).slice(0, 2).join(" · ")}
        </div>
      </div>

      <div className="mt-3 text-center uppercase text-[10px] tracking-[0.35em] text-[#4A4B46]" style={{ fontFamily: "Special Elite, monospace" }}>
        timecapsule24 · a daily portal to the past
      </div>
    </div>
  );
}
